// The icon of each pitch a piece gives: a shield for the careful one and a
// flame for the aggro one. Added 2026-10-13. A badge had the letter C or A.
// Garrett: "can we have icons instead for careful/aggro on the horses
// themselves". He chose the pair from three drawn sets. The badge of the
// piece, its row in the inspector, and its button in the cue draw the same
// path. The pitch of suggest-best comes from no piece and has no icon.

import type { Pitch } from '../engine/types';
import { svg } from '../lib/svg';

/** Each path is centered on zero and reaches about 8.5 units from it, as the mark of a badge does. */
export const PITCH_ICON_PATHS: Record<Pitch, string> = {
  careful: 'M0 -7.5 L6.5 -5 V0.5 C6.5 4.2 3.4 6.6 0 8 C-3.4 6.6 -6.5 4.2 -6.5 0.5 V-5 Z',
  aggro:
    'M0.5 -8.5 C1 -4.5 6.2 -2.5 6.2 2.5 C6.2 5.8 3.4 8 0 8 C-3.4 8 -6.2 5.8 -6.2 2.5 C-6.2 0 -4.6 -1.2 -3.8 -3.6 C-2.6 -2.8 -2 -1.8 -1.6 -0.6 C-1.2 -3.2 -0.8 -5.6 0.5 -8.5 Z',
};

/** Half of the box of an icon that stands alone, with a little room around the path. */
const ICON_BOX_RADIUS = 10;

/** The icon as an element of its own, in the color of the text around it. */
export const createPitchIcon = (pitch: Pitch, className: string): SVGSVGElement =>
  svg(
    'svg',
    {
      class: className,
      viewBox: `${-ICON_BOX_RADIUS} ${-ICON_BOX_RADIUS} ${ICON_BOX_RADIUS * 2} ${ICON_BOX_RADIUS * 2}`,
      'aria-hidden': 'true',
    },
    [svg('path', { d: PITCH_ICON_PATHS[pitch] })],
  );
